import animateScrollTo from "animated-scroll-to";

export const linkEffect = function (el) {
    el.querySelectorAll("a").forEach(function (link) {
        link.addEventListener("click", function () {
            animateScrollTo(0, {
                easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
                minDuration: 250,
                speed: 250,
                verticalOffset: 0,
            });
        });
    });
};
